import { api, postgresAPI } from '../api';

/** Create
 * @param { String: "/route" } route
 * @param { Object } data
 */
export function create(route, data) {
  return api.post(route, { ...data });
}

/** Get All
 * @param { String: "/route" } route
 * @param { Object: { page: # } } data
 */
export function getAll(route) {
  return api.get(route);
}

/** Get
 * @param { String: "/route" } route
 * @param { Number: 1 } id
 */
export function get(route, data) {
  return api.get(`${route}${data}`);
}

/** Update
 * @param { String: "/route" } route
 * @param { Object } data
 */
export function update(route, data) {
  return api.put(`${route}/${data.id}`, {
    ...data,
  });
}

/** Delete
 * @param { String: "/route" } route
 * @param { Number: 1 } id
 */
export function remove(route, id) {
  return api.delete(`${route}/${id}`);
}

/** Modular GraphQL Postgres Endpoint
 * @param { Object } data
 */
export function graphQL(data) {
  return postgresAPI.post('', { ...data });
}
